import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { StepCard } from "./StepCard";
import { WalletQR } from "./WalletQR";

interface DepositFromBinanceProps {
  walletAddress: string;
}

function DepositFromBinance({ walletAddress }: DepositFromBinanceProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div className="flex items-start gap-2 rounded-lg border border-warning-200 bg-warning-50 p-3 dark:border-warning-700 dark:bg-warning-900/20">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-warning-600 dark:text-warning-400" />
        <p className="text-xs text-warning-700 dark:text-warning-300">
          {t("ramp.binanceDepositWarning", "Polygon network only. Other networks = lost funds.")}
        </p>
      </div>

      <div className="flex justify-center">
        <WalletQR address={walletAddress} />
      </div>

      <div className="space-y-3">
        <StepCard step={1} title={t("ramp.binanceDepositStep1", "On Binance: Withdraw → USDT")} />
        <StepCard step={2} title={t("ramp.binanceDepositStep2", "Paste address. Network: Polygon")} />
        <StepCard step={3} title={t("ramp.binanceDepositStep3", "Confirm. Done.")} />
      </div>
    </div>
  );
}

export { DepositFromBinance };
